import { tw } from "@careinfo/tailwind";

const FormCheckbox = ({ name, label, register, watch, setValue }) => {
  const checked = watch(name);

  const handleChange = (e) => {
    setValue(name, e.target.checked);
  };

  return (
    <label className={tw`inline-flex  items-center cursor-pointer`}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={handleChange}
        {...register(name)}
        className={tw`w-4 h-4`}
      />
      {label && <span className={tw`ml-2`}>{label}</span>}
    </label>
  );
};

export default FormCheckbox;
